import api from './client';
export const coaApi = {
  list:         ()           => api.get('/coa'),
  store:        (data: any)  => api.post('/coa', data),
  accountTypes: ()           => api.get('/coa/account-types'),
};
